import { render, staticRenderFns } from "./zuheShangpin.vue?vue&type=template&id=37d81bcf&scoped=true"
import script from "./zuheShangpin.vue?vue&type=script&lang=js"
export * from "./zuheShangpin.vue?vue&type=script&lang=js"
import style0 from "./zuheShangpin.vue?vue&type=style&index=0&id=37d81bcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d81bcf",
  null
  
)

export default component.exports